var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotes = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 24,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 22 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1F2124",
  d: "M4.25.75a.75.75 0 0 1 1.5 0V4.5h-1.5zM10.25.75a.75.75 0 0 1 1.5 0V4.5h-1.5zM16.25.75a.75.75 0 0 1 1.5 0V4.5h-1.5zM7.25 1.5h1.5V3h-1.5zM13.25 1.5h1.5V3h-1.5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1F2124",
  d: "M.5 3.75A2.25 2.25 0 0 1 2.75 1.5V3a.75.75 0 0 0-.75.75v18c0 .414.336.75.75.75h16.5a.75.75 0 0 0 .75-.75v-18a.75.75 0 0 0-.75-.75V1.5a2.25 2.25 0 0 1 2.25 2.25v18A2.25 2.25 0 0 1 19.25 24H2.75A2.25 2.25 0 0 1 .5 21.75z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#1F2124",
  d: "M14.75 7.5H8V9h6.75zM9.5 20.25v-1.5H5v1.5zM17 16.5V15H5v1.5zM13.25 11.25H5v1.5h8.25zM6.5 9V7.5H5V9z"
})));
export default SvgNotes;